enum TimelineWindowSizes {
  YEAR = "YEAR",
  QUARTER = "QUARTER",
  MONTH = "MONTH",
  WEEK = "WEEK",
  THREE_DAYS = "THREE_DAYS",
  DAY = "DAY",
}

export default TimelineWindowSizes
